import * as React from 'react';
import { useCallback } from 'react';
import { DealPreferenceDraggableCard } from './DealPreferenceDraggableCard';
import update from 'immutability-helper';
import { Skeleton, styled } from '@mui/material';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { CerebroText } from './CerebroText';

export interface DealPreferenceItem {
	index: number;
	propertyName: 'PricePriority' | 'CovenantPriority' | 'MaturityPriority' | 'AmortizationPriority' | 'AmountPriority';
	displayName: string;
}

export interface DealPreferenceDragAndDropProps {
	skeleton?: boolean;
	items: DealPreferenceItem[];
	setItems: React.Dispatch<React.SetStateAction<DealPreferenceItem[]>>;
}

export const DealPreferenceDragAndDrop: React.FC<DealPreferenceDragAndDropProps> = ({
	skeleton = false,
	items,
	setItems,
}) => {
	const moveCard = useCallback(
		(dragIndex: number, hoverIndex: number) => {
			setItems((prevCards: DealPreferenceItem[]) =>
				update(prevCards, {
					$splice: [
						[dragIndex, 1],
						[hoverIndex, 0, prevCards[dragIndex] as DealPreferenceItem],
					],
				})
			);
		},
		[setItems]
	);

	return (
		<DndProvider backend={HTML5Backend}>
			<StyledWrapper>
				<CerebroText variant="hint" weight="medium">
					Most Important
				</CerebroText>

				{items.map((card, index) =>
					skeleton ? (
						<Skeleton key={card.index} height={60} />
					) : (
						<DealPreferenceDraggableCard
							key={card.index}
							index={index}
							id={card.index}
							text={card.displayName}
							onChange={moveCard}
						/>
					)
				)}

				<CerebroText variant="hint" weight="medium">
					Least Important
				</CerebroText>
			</StyledWrapper>
		</DndProvider>
	);
};

const StyledWrapper = styled('div')(({ theme }) => ({
	backgroundColor: theme.palette.common.white,
	borderWidth: 3,
	padding: 20,
	borderStyle: 'dashed',
	borderColor: theme.palette.gray.medium,
	borderRadius: theme.shape.borderRadius,
	marginBottom: 8,
}));
